module.exports = __webpack_public_path__ + "img/4d5b635.jpg";